import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { Snowplow2StatsSchemaBrokerSearchContextInterface } from '../schema/broker-search-context.interface';

export class Snowplow2StatsAdapterSchemaBrokerSearchContext implements StatsAdapterInterface {
  /**
   *
   * @param context
   */
  constructor(protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): Snowplow2StatsSchemaBrokerSearchContextInterface {
    if (!this.context.global.broker_search) {
      throw new Error('Stats context "broker_search" is not set.');
    }

    const schema: Snowplow2StatsSchemaBrokerSearchContextInterface = {
      schema: 'iglu:ae.propertyfinder/broker_search_context/jsonschema/1-0-1',
      data: {},
    };

    // Keywords
    if (this.context.global.broker_search.text !== undefined) {
      schema.data.keywords = this.context.global.broker_search.text;
    }

    // Locations
    if (this.context.global.broker_search.location_id !== undefined) {
      schema.data.locations = [String(this.context.global.broker_search.location_id)];
    }

    // Broker
    if (this.context.global.broker_search.broker_id !== undefined) {
      schema.data.broker_id = this.context.global.broker_search.broker_id;
    }

    return schema;
  }
}
